import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { useLoading } from '../../contexts/LoadingContext';

// Styled overlay container
const OverlayContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  backdropFilter: 'blur(3px)',
  transition: 'opacity 0.3s ease-in-out',
}));

// Styled spinner container
const SpinnerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: theme.spacing(3),
  boxShadow: theme.shadows[10],
}));

// Only show request count in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

export const LoadingOverlay = () => {
  const { isLoading, pendingRequests } = useLoading();
  
  if (!isLoading) return null;
  
  return (
    <OverlayContainer>
      <SpinnerContainer>
        <CircularProgress 
          size={60} 
          thickness={4} 
          sx={{ 
            color: (theme) => theme.palette.primary.main,
            marginBottom: 2
          }} 
        />
        <Typography variant="h6" color="primary">
          Loading...
        </Typography>
        
        {/* {isDevelopment && pendingRequests > 0 && (
          <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
            Pending requests: {pendingRequests}
          </Typography>
        )} */}
      </SpinnerContainer>
    </OverlayContainer>
  );
}; 